import React from 'react'
import { Row, Checkbox, Button, DialogOverlay, DialogOverlayActions } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function QueueColumnsDialogOverlay({
  queueColumns,
  activeColumns,
  onColumnChange,
  ...queueColumnsOverlay
}) {
  const { t } = useTranslation()
  return (
    <DialogOverlay title={t('queues.setColumns', 'Set Columns')} {...queueColumnsOverlay}>
      <Row wrap>
        {queueColumns?.map((column) => (
          <Checkbox
            key={column}
            label={t(`queues.${column}`, column)}
            name={column}
            checked={activeColumns?.includes(column)}
            onChange={() => onColumnChange(column)}
          />
        ))}
      </Row>
      <DialogOverlayActions>
        <Button emphasis="high" onClick={queueColumnsOverlay.close}>
          {t('action.done', 'Done')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
